export function formatArraySelect(data: Array<Object>) {
  return data && data.map((item: any) => {
    return formatDataSelect(item)
  })
}

export function formatDataSelect(item: any) {
  return {
    item,
    value: item && item.id,
    label: (item && item.title) || (item && item.name),
  }
}
